import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import cardImg from "../images/Ai_card_img.png";

const programs = [
  {
    title: "AI Filmmaking",
    duration: "1 Year",
    level: "Diploma",
    desc: "Create cinematic content using AI tools — from scriptwriting to post-production. Learn generative AI for VFX, automated editing workflows, and AI-driven storytelling.",
    highlights: ["AI Video Generation", "Smart Editing", "VFX with AI", "Distribution Strategy"],
  },
  {
    title: "Remedial Education",
    duration: "6 Months",
    level: "Certificate",
    desc: "Specialized teaching methods to help struggling learners succeed. Master diagnostic assessment, individualized instruction, and adaptive learning technologies.",
    highlights: ["Diagnostic Assessment", "IEP Development", "Adaptive Tech", "Student Psychology"],
  },
  {
    title: "Wealth Management",
    duration: "1 Year",
    level: "Professional Diploma",
    desc: "Comprehensive financial planning and investment management. Cover portfolio theory, risk management, estate planning, and client relationship building.",
    highlights: ["Portfolio Management", "Tax Planning", "Risk Analysis", "Client Advisory"],
  },
  {
    title: "Business Automation",
    duration: "8 Months",
    level: "Diploma",
    desc: "Automate business processes using no-code/low-code platforms, RPA, and AI. Transform operational efficiency across marketing, HR, finance, and operations.",
    highlights: ["RPA Tools", "No-Code Platforms", "AI Integration", "Process Optimization"],
  },
  {
    title: "Digital Marketing",
    duration: "6 Months",
    level: "Certificate",
    desc: "Master the digital ecosystem — SEO, paid ads, content strategy, social media marketing, email automation, and data-driven campaign optimization.",
    highlights: ["SEO & SEM", "Social Media", "Content Strategy", "Analytics"],
  },
  {
    title: "Data Analytics",
    duration: "1 Year",
    level: "BVoc Specialization",
    desc: "Transform raw data into business intelligence. Learn Python, SQL, visualization tools, statistical modeling, and machine learning fundamentals.",
    highlights: ["Python & SQL", "Power BI / Tableau", "Statistical Modeling", "ML Basics"],
  },
];

function Courses() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="page-header">
        <div className="container text-center">
          <h1 className="fw-bold text-white" data-aos="fade-down">Our Programs</h1>
          <p className="text-white-50 mt-2" data-aos="fade-up">
            Industry-aligned courses designed to make you job-ready from day one
          </p>
        </div>
      </section>

      {/* Programs Grid */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4">
            {programs.map((prog, i) => (
              <div className="col-lg-6" key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="program-card d-flex flex-column flex-md-row h-100">
                  <div className="program-card-img">
                    <img src={cardImg} alt={prog.title} />
                    <span className="program-badge">{prog.level}</span>
                  </div>
                  <div className="program-card-body">
                    <h5 className="fw-semibold">{prog.title}</h5>
                    <span className="program-duration">
                      <i className="bi bi-clock me-1"></i>{prog.duration}
                    </span>
                    <p className="text-muted small mt-2">{prog.desc}</p>
                    <div className="program-highlights">
                      {prog.highlights.map((h, j) => (
                        <span key={j} className="highlight-tag">{h}</span>
                      ))}
                    </div>
                    <Link to="/contact" className="btn-details mt-3">
                      Apply Now <i className="bi bi-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="partners-section py-5">
        <div className="container text-center">
          <h3 className="text-white fw-bold" data-aos="fade-up">Can't decide? We'll help you choose.</h3>
          <p className="text-white-50 mt-2" data-aos="fade-up">
            Book a free career counselling session and find the program that matches your goals.
          </p>
          <Link to="/contact" className="btn btn-light px-4 py-2 mt-3 fw-semibold" data-aos="zoom-in">
            Get Free Counselling
          </Link>
        </div>
      </section>
    </>
  );
}

export default Courses;
